import styled from "styled-components";
import colors from "../../../../../config/colors";
import { Scrollable } from "../../../../../common/styles";

export const ReassignMenteeContainer = styled.div`
    width:${props=>props.width ? props.width :'40vw'};
    overflow-y: scroll;
    ${Scrollable};
    height: ${props=>props.height ? props.height :'60vh'};
    @media ( max-width: 640px ) {
        width:100%;
    }
`;
export const MentorRow = styled.div`
padding:10px;
display:flex;
align-items:center;
justify-content:space-between;
border: 1px solid ${colors.secondary};
border-radius:5px;
margin-bottom:10px;
@media (max-width:640px) {
   flex-direction:column;
   gap:5px;
   align-items: flex-start;
}
`;

export const MentorInfo = styled.div`
    display: flex;
    align-items: center;
`;
export const MentorImage = styled.img`
    height:40px;
    width:40px;
    object-fit:cover;
    border-radius:50%;
`;
export const MentorName = styled.div`
    color: #302F2F;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-weight: 400;
    text-transform:capitalize;
    margin-left:10px;
`;

export const SearchBoxContainer = styled.div`
    position:relative;
    width:300px;
    @media (max-width:1366px) {
        order: 1;
        width:100%;
    }
    @media (max-width:991px) {
        order: 0;
        max-width:400px;
    }
`;

export const SearchIcon = styled.div`
    position:absolute;
    left:10px;
    top:10px;
    z-index: 9;
`;

export const TitleBorderSeperator = styled.div`
    position:relative;
    padding-top:20px;
    margin-bottom:10px;
        &:before {
            content:'';
            position:absolute;
            left:-18px;
            top:0;
            width:calc(100% + 35px);
            height:1px;
            background-color:#ededed;
        }
`;